import React from 'react';
import logo from '../../assets/logo/lfz_logo_flag.svg';
import { Link, NavLink } from 'react-router-dom';

const Header = () => {
    return (
        <div className='flex items-end justify-between lg:mt-[80px] mt-10'>
            <Link to={"/"}>
                <img className='lg:w-[400px] w-[200px]' src={logo} alt="" />
            </Link>
            <div className="flex justify-center items-center lg:gap-10 gap-5 transition-all duration-300 ease-in-out">
                <NavLink
                    className={({ isActive }) => isActive ? "text-lifeorange lg:text-[24px] text-[16px] font-chido transition-all duration-300 ease-in-out" : "text-offblack hover:border-b-2 border-lifeorange lg:text-[14px] text-[12px] font-chido transition-all duration-300 hover:duration-100 ease-in-out"}
                    to="/">HOME</NavLink>
                <NavLink
                    className={({ isActive }) => isActive ? "text-lifeorange lg:text-[24px] text-[16px] font-chido transition-all duration-300 ease-in-out" : "text-offblack hover:border-b-2 border-lifeorange lg:text-[14px] text-[12px] font-chido transition-all duration-300 hover:duration-100 ease-in-out"}
                    to="/about-us">ABOUT US</NavLink>
            </div>
        </div>
    )
}

export default Header